import packageJson from "../../package.json";

const localStorageKeys = {
  APP_VERSION: `@@${packageJson.name}-version`,
  USER_ID: `@@${packageJson.name}-user-id`,
  USER_NAME: `@@${packageJson.name}-user-name`,
  USER_EMAIL: `@@${packageJson.name}-user-email`,
  USER_LIKES: `@@${packageJson.name}-user-likes`,
};

export default localStorageKeys;
